import React, { useState, useMemo } from 'react';
import { Box, Button, TextField, Typography, Stack, Paper } from '@mui/material';
import axios from 'axios';
import FlashcardPreview from './FlashcardPreview';

export default function FlashcardsManager() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [pasteInput, setPasteInput] = useState('');
  const [saving, setSaving] = useState(false);
  const [cards, setCards] = useState([]);

  const parsedCards = useMemo(() => {
    const rows = pasteInput.split(/\r?\n/).filter(r => r.trim().length);
    const out = [];
    rows.forEach((r, idx) => {
      // Split by tab preferred, fallback to comma
      const parts = r.split('\t');
      const [a, b] = parts.length >= 2 ? parts : r.split(',');
      if (a && b) {
        out.push({ side_a: a.trim(), side_b: b.trim(), order_index: idx });
      }
    });
    return out;
  }, [pasteInput]);

  const handlePreview = () => {
    setCards(parsedCards);
  };

  const handleSave = async () => {
    if (!title.trim()) {
      alert('Please enter a set title');
      return;
    }
    if (parsedCards.length === 0) {
      alert('Please paste at least one row with Side A and Side B');
      return;
    }
    setSaving(true);
    try {
      // Create set
      const setResp = await axios.post('/api/flashcards/sets', { title, description });
      const setId = setResp.data?.data?.id;
      if (!setId) throw new Error('Set creation failed');
      // Bulk create cards
      const bulkResp = await axios.post(`/api/flashcards/sets/${setId}/cards/bulk`, { cards: parsedCards });
      const created = bulkResp.data?.count || 0;
      setCards(parsedCards);
      alert(`Saved ${created} cards to set "${title}"`);
    } catch (e) {
      console.error(e);
      alert(`Save failed: ${e.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Flashcards Manager</Typography>
      <Stack spacing={2}>
        <TextField label="Set Title" value={title} onChange={e => setTitle(e.target.value)} fullWidth />
        <TextField label="Description" value={description} onChange={e => setDescription(e.target.value)} fullWidth />
        <TextField label="Paste rows (Side A\tSide B)" value={pasteInput} onChange={e => setPasteInput(e.target.value)} fullWidth multiline minRows={6} />
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={handlePreview}>Preview</Button>
          <Button variant="contained" onClick={handleSave} disabled={saving}>Save to Database</Button>
        </Stack>
        {cards.length > 0 && (
          <Paper sx={{ p:2 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>Preview ({cards.length} cards)</Typography>
            <Stack spacing={2}>
              {cards.map((c, i) => (
                <FlashcardPreview key={i} card={c} />
              ))}
            </Stack>
          </Paper>
        )}
      </Stack>
    </Box>
  );
}
